module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-header table-row"
  }, [_c('div', {
    staticClass: "table-col specific-template-step"
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.stage')))]), _c('div', {
    staticClass: "table-col table-col-200 specific-template-name"
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.nameTemplate')))]), _c('div', {
    staticClass: "table-col specific-template-category"
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.category')))]), _c('div', {
    staticClass: "table-col table-col-200 specific-template-body"
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.subject')))]), _c('div', {
    staticClass: "table-col-collapsed specific-template-actions"
  }), _c('div', {
    staticClass: "table-col-collapsed specific-template-actions"
  })]), _c('div', {
    staticClass: "table-body"
  }, _vm._l((_vm.flow.actions), function(action, action_id) {
    return _c('specific-template-list-item', {
      attrs: {
        "flow": _vm.flow,
        "action": action,
        "contact": _vm.contact
      },
      on: {
        "specific-template-edit": _vm.bubbleUp,
        "specific-template-destroy": _vm.bubbleUp
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09973305!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/specific_templates/list.vue
// module id = 1007
// module chunks = 1